import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useRoleColumns() {
	const i18n = useI18n()
	const cols = columnStore()

	const name = cols.define('roles', 'name', i18n.t('misc.name'), true)
	const description = cols.define('roles', 'description', i18n.t('description'), true)
	const user = cols.define('roles', 'user', i18n.t('user.label', 2), true)

	const columns = { name, description, user }

	const { custom, all } = cols.finalize('roles', columns)

	return { columns, custom, all }
}
